import {PRODUCT_TYPES} from 'constants/product';
import {TypPrepareProductDataType} from 'desktop/pages/success/types/types';
import {getLensType} from 'libs/lensType';
import {isGlasses, isAccessory} from 'libs/typeCheck/typeCheck';

import {GetQuoteType} from 'mobile/actions/checkout/checkout';

type PossibleValuesType = string | number | null;

/**
 * Check than incoming value is not equal to null, zero, empty string and undefined and return correct string
 *
 * @param {PossibleValuesType} value - Received value.
 * @returns {string} - Returned value.
 */
// ts-unused-exports:disable-next-line
export const emptyStringIsFalsy = (value?: PossibleValuesType): string =>
    value ? String(value) : '';

/**
 * Get attribute.
 *
 * @param {string} type - Product type.
 * @returns {string} - Attribute.
 */
// ts-unused-exports:disable-next-line
export const getAttribute = (type: string): string =>
    type === PRODUCT_TYPES.CONTACT_LENSES ? 'lenses' : 'frames';

/**
 * Get string data.
 *
 * @param {Array<string>|string} data - Data.
 * @returns {string|number} - String data.
 */
// ts-unused-exports:disable-next-line
export const getStringDataFormArray = (
    data: string[] | string | {code: string; title: string}[],
): string => emptyStringIsFalsy(Array.isArray(data) ? data.join(' / ') : data);

/**
 * Get data for product frame.
 *
 * @param {CartItemType} product - Quote item.
 * @returns {{color: string, item_price: number, size: string}} Type check result.
 */
// ts-unused-exports:disable-next-line
export const getFrameData = (
    product: GetQuoteType['quoteItems'][0],
): {color: string; item_price: number; size: string} => ({
    color: isGlasses(product) && product.frame ? emptyStringIsFalsy(product.frame.color) : '',
    item_price: isGlasses(product) && product.frame ? Number(product.frame.price) : 0,
    size: isGlasses(product) && product.frame ? emptyStringIsFalsy(product.frame.frameSize) : '',
});

/**
 * Prepare quote item.
 *
 * @param {CartItemType} product - Quote item.
 * @returns {TypPrepareProductDataType} - Returned product data prepared for Global Data Layer.
 */
export const prepareProductData = (
    product: GetQuoteType['quoteItems'][0],
): TypPrepareProductDataType => ({
    attribute_set: getAttribute(product.type),
    brand: emptyStringIsFalsy(product.brand),
    frame_url_path: emptyStringIsFalsy(product.frame_url_path),
    full_sku: emptyStringIsFalsy(product.sku),
    gender: isGlasses(product) ? getStringDataFormArray(product.gender) : '',
    glasses_type: emptyStringIsFalsy(product.type),
    image_1_url_path: '',
    image_2_url_path: product.img,
    image_3_url_path: '',
    lens_type: isGlasses(product) || isAccessory(product) ? getLensType(product) : '',
    product_badge:
        isGlasses(product) || isAccessory(product) ? getStringDataFormArray(product.badges) : '',
    product_id: product.id,
    product_name: emptyStringIsFalsy(product.name),
    quantity: Number(product.qty),
    sku: emptyStringIsFalsy(product.product_sku),
    window_name: emptyStringIsFalsy(product.window_name),
    ...getFrameData(product),
});
